import { api } from '../common.api';

export interface MigrationResult {
  users?: {
    totalUsers: number;
    migratedUsers: number;
    skippedUsers: number;
    errors: string[];
  };
  promos?: {
    totalPromos: number;
    migratedPromos: number;
    skippedPromos: number;
    errors: string[];
  };
  employers?: {
    totalEmployers: number;
    migratedEmployers: number;
    migratedRooftops: number;
    skippedEmployers: number;
    errors: string[];
  };
  jobseekers?: {
    totalJobseekers: number;
    migratedJobseekers: number;
    migratedExperiences: number;
    migratedEducations: number;
    migratedReferences: number;
    migratedCertificates: number;
    migratedAssociations: number;
    skippedJobseekers: number;
    errors: string[];
  };
  posts?: {
    totalJobs: number;
    migratedJobs: number;
    migratedPosts: number;
    skippedJobs: number;
    errors: string[];
  };
  applications?: {
    totalApplications: number;
    migratedApplications: number;
    skippedApplications: number;
    errors: string[];
  };
  campaigns?: {
    totalCampaigns: number;
    migratedCampaigns: number;
    skippedCampaigns: number;
    errors: string[];
  };
  invoices?: {
    totalInvoices: number;
    migratedInvoices: number;
    skippedInvoices: number;
    errors: string[];
  };
  chat?: {
    totalMessages: number;
    migratedChatRooms: number;
    migratedMessages: number;
    skippedMessages: number;
    errors: string[];
  };
}

export interface TalrooTestRequest {
  postId: string;
  source: string;
  timestamp: string;
  signature: string;
  jsonData: string;
}

export interface TalrooTestResponse {
  success: boolean;
  message: string;
  error?: string;
}

export const debugApi = api.injectEndpoints({
  endpoints: (builder) => ({
    uploadMigrationFile: builder.mutation<MigrationResult, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append('sqlFile', file);

        return {
          url: '/debug/migration',
          method: 'POST',
          body: formData,
        };
      },
    }),
    testTalrooEndpoint: builder.mutation<TalrooTestResponse, TalrooTestRequest>({
      query: ({ postId, source, timestamp, signature, jsonData }) => {
        let parsedData;
        try {
          parsedData = JSON.parse(jsonData);
        } catch (error) {
          throw new Error('Invalid JSON data');
        }

        return {
          url: `/partner/talroo/apply/${postId}?source=${source}`,
          method: 'POST',
          headers: {
            'x-talroo-signature': `t=${timestamp}, v1=${signature}`,
            'Content-Type': 'application/json',
          },
          body: parsedData,
        };
      },
    }),
  }),
});

export const { useUploadMigrationFileMutation, useTestTalrooEndpointMutation } = debugApi;
